import { motion } from 'framer-motion';

const Footer = () => {

  const footerLinks = [
    {
      title: 'Navigation',
      links: [
        { name: 'Home', url: '/' },
        { name: 'About Us', url: '/about' },
        { name: 'Testimonials', url: '/testimonials' },
        { name: 'Contact Us', url: '/contact' },
      ],
    },
    {
      title: 'Listings',
      links: [
        { name: 'Browse All Listings', url: '/' },
        { name: 'Listings in India', url: '/' },
        { name: 'Listings in Bali', url: '/' },
        { name: 'Online Training', url: '/' },
      ],
    },
    {
      title: 'Services',
      links: [
        { name: 'Free Consultation', url: '/consultation' },
        { name: 'School Matching', url: '/consultation' },
        { name: 'Career Guidance', url: '/consultation' },
        { name: 'Application Support', url: '/consultation' },
      ],
    },
  ];

  return (
    <footer 
      className="pt-16 pb-8 border-t border-ivory-200 relative z-0"
      style={{
        background:`#fefbf4 url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.25'/%3E%3C/svg%3E") repeat`
        // background: '#FDFBF3',
        // backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4"><path fill="%23ffffff" fill-opacity="0.03" d="M1 3h1v1H1V3zm2-2h1v1H3V1z"/></svg>')`
      }}
    >
      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Contact Information */}
          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="mb-4"
            >
              <img 
                src="/images/logo.png" 
                alt="BookMyYogaTTC Logo" 
                className="h-16 w-auto object-contain"
              />
            </motion.div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="text-ivory-700 mb-6 font-light leading-relaxed"
            >
              Expert yoga consultation services connecting students with authentic teacher training programs worldwide. 
              Find your perfect yoga school through personalized guidance and support.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-ivory-700 text-2"
            >
              <p className="mb-2">📧 info@bookmyyogattc.com</p>
              <p className="mb-2">📞 +1 (555) 123-YOGA</p>
              <p>🌍 Serving students globally</p>
            </motion.div>
          </div>

          {/* Footer Links */}
          {footerLinks.map((section, index) => (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <h4 className="text-4 font-medium mb-4 text-ivory-900">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.url}
                      className="text-ivory-600 hover:text-orange transition-colors duration-300 font-light"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Inspirational Quote */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center py-8 border-y border-ivory-200"
        >
          <p className="text-ivory-700 font-light italic text-4 mb-2">
            "The success of yoga lies in finding the right teacher and the right path for your unique journey."
          </p>
          <p className="text-ivory-600 text-2">- bookmyyogattc Philosophy</p>
        </motion.div>

        {/* Bottom Bar */}
        <div className="pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-ivory-600 text-2 mb-4 md:mb-0 font-light">
              © {new Date().getFullYear()} bookmyyogattc. All rights reserved. Made with 🤍 for aspiring yoga teachers worldwide.
            </p>
            <div className="flex space-x-6">
              <a href="/privacy" className="text-ivory-600 hover:text-primary text-2 transition-colors duration-300 font-light">
                Privacy Policy
              </a>
              <a href="/terms" className="text-ivory-600 hover:text-primary text-2 transition-colors duration-300 font-light">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 